module.exports = __webpack_public_path__ + "static/media/SELECTstage6.2907b225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/SELECTstage6.png
// module id = 171
// module chunks = 0